export enum AnnouncementCategory {
  Welcome = 100,
  Closed = 101,
  Queue = 102,
  Periodic = 103,
  Overflow = 104,
  CompanyVoicemail = 105,
  Lunch = 106,
  Menu = 107,
  Custom = 200
}
